import { render } from "./BcadsaiView.vue?vue&type=template&id=62f98fa4"
import script from "./BcadsaiView.vue?vue&type=script&lang=js"
export * from "./BcadsaiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__